import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Law } from "../../models/laws";
import {RegistrationLaw} from "../../models/registration-law";
import Helpers from "../../utils/helpers";

@Injectable()
export class RegistrationLawControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getRegistrationLawsList(registrationId: string): Observable<Law[]> {
    return this.http.get(this.baseUrl + "registration/" + registrationId + "/registration_law") as Observable<Law[]>;
  }

  public getRegistrationLaw(registrationLawId: string): Observable<Law> {
    return this.http.get(this.baseUrl + "registration_law/" + registrationLawId) as Observable<Law>;
  }

  public saveRegistrationLaw(registrationLaw: RegistrationLaw) {
    Helpers.trimRecursiveObj(registrationLaw);
    const body = JSON.stringify(registrationLaw);
    return this.http.put(this.baseUrl + "registration_law", body, { responseType: "text" });
  }

  public createRegistrationLaw(registrationId: string, registrationLaw: RegistrationLaw) {
    Helpers.trimRecursiveObj(registrationLaw);
    const body = JSON.stringify(registrationLaw);
    return this.http.post(this.baseUrl + "registration/" + registrationId + "/registration_law", body);
  }

  public deleteRegistrationLaw(registrationLawId: string) {
    return this.http.delete(this.baseUrl + "registration_law/" + registrationLawId, { responseType: "text" });
  }

  public updateSortOrder(registrationLaws: RegistrationLaw[]) {
    const body = JSON.stringify(registrationLaws);
    return this.http.put(this.baseUrl + "sort_registration_laws", body, { responseType: "text" });
  }
}
